import React, { useState, useMemo, useContext } from 'react';
import useDimensions from 'react-use-dimensions';
import { scaleLinear } from 'd3-scale';
import sortBy from 'lodash.sortby';

import Links from '../Links';

import backgroundChords from '../images/intro-background-chords.svg';

import './styles.scss';
import { LanguageContext, localize } from '../Localization'

// const summaryColors = ['#C56415', '#97D7FB', '#255678', '#784A25'];
const summaryColors = ['#2985C5', '#C56415', 'rgba(197, 100, 21, 0.5)', 'rgba(106, 116, 122, 0.82)'];
const xScale = scaleLinear();

export default function Intro(props) {
  const { totalValue, summaryData } = props;

  const [barRef, { width }] = useDimensions();

  const [tooltip, setTooltip] = useState();

  const language = useContext(LanguageContext)

  const bars = useMemo(() => {
    if (summaryData.length && width) {
      const summaryValues = sortBy(summaryData.map(d => d.value), d => -d);
      const minWidth = 152;
      const innerMin = 112;
      summaryValues.pop();
      const wide = window.innerWidth > 1024;
      const adjustedTotal = wide
        ? summaryValues.reduce((a, v) => a + v, 0)
        : Math.max(...summaryValues);

      const scaleWidth = wide
        ? width - (minWidth + (innerMin / 2) + 1)
        : width;
      xScale
        .domain([0, adjustedTotal])
        .range([0, scaleWidth]);

      return summaryData.map((group, i) => {
        const isLast = i === summaryData.length -1;
        const width = wide
          ? isLast
            ? xScale(group.value)
            : Math.max(innerMin, xScale(group.value))
          : xScale(group.value);
        const background = summaryColors[i];
        const height = wide
          ? '4em'
          : '2.625em';
        const outerWidth = wide
          ? isLast
            ? minWidth
            : width
          : '100%';

          const key = group.key.toLowerCase()

        return (
          <div key={key} className='group' style={{ width: outerWidth }}>
            <div className='label small' style={{ paddingRight: isLast ? 0 : '0.5em' }}>
              <span>
                {localize(language, 'landing', `${key} label`)}
              </span>
            </div>
            <div className='rect' style={{ width: outerWidth }}>
              <div className='bar' data-name={key} style={{ width, height, background }} />
            </div>
            <div className='label large'>
              <span>
                ${group.value.toLocaleString()}
              </span>
            </div>
          </div>
        );
      });
    }
    return null;
  }, [summaryData, width, language]);

  return (
    <div className='Intro' style={{ backgroundImage: `url(${backgroundChords})` }}>
      <div className='sectionContainer'>
        <div className='section intro'>
          <p>
            {localize(language, 'landing', 'introduction') }
          </p>
        </div>
      </div>
      <div
        className='sectionContainer'
        style={{ flex: 'auto', background: 'rgba(151, 215, 251, 0.16)' }}
        onMouseOut={() => setTooltip(null)}
      >
        <div className='section'>
          <div className='totalLabel'>

            {localize(language, 'landing', 'title') }
          </div>
          <div className='totalValue'>
            ${totalValue.toLocaleString()}
          </div>
        </div>
        <div
          className='section'
          style={{ padding: 0 }}
          onMouseMove={e => {
            const { pageX, pageY, target } = e;
            const { dataset } = target;
            if (Object.keys(dataset).length) {
              setTooltip({
                x: pageX,
                y: pageY,
                ...dataset,
              });
            } else {
              setTooltip(null);
            }
          }}
        >
          <div
            ref={barRef}
            className='bars'
          >
            {bars}
          </div>
        </div>
        <div className='section links'>
          <Links
            style={{ marginBottom: '1em' }}
          />
        </div>
      </div>
      {
        tooltip ? (
          <div
            className='tooltip'
            style={{
              marginLeft: tooltip.x,
              marginTop: tooltip.y,
              transform: `translate(${tooltip.x > window.innerWidth / 2 ? '-105%' : '5%'}, -100%)`,
            }}
          >
            <div className='row name'>
              <div className='label'>
                {localize(language, 'landing', `${tooltip.name} label`)}

              </div>
            </div>
            <div className='row'>
              <div className='label'>
              {localize(language, 'landing', `${tooltip.name} description`)}
              </div>
            </div>
          </div>
        ) : null
      }
    </div>
  );
}
